export default __webpack_public_path__ + "static/media/IMG_4075.ccdfb2bd.jpg";